<app-dropdown-select
	[tooltip]="'Limit Timeframe'"
	[control]="control"
	[options]="whenOptions"
	[label]="'Timeframe'"
	dropdownMenuClass="checkbox-dropdown"
></app-dropdown-select>
